import image from 'assets/image/snail-looking-for.png'
import { AuthTemplate } from 'components/templates/authTemplate'
import { CONSTS } from 'config/objectConst.js'
import { Link } from 'react-router-dom'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

const cn = AuthTemplate.cn

const TITLE = `Oops! We couldn’t connect ${CONSTS.PROJECT_NAME} to your account`

export const BadAuthContainer = () => (
	<AuthTemplate active={2} show={2}>
		<h1 className={cn.title} style={{ maxInlineSize: '37rem' }}>
			{TITLE}
		</h1>

		<img
			alt='unAuth'
			className={cn.image}
			height={150}
			src={image}
			width={150}
		/>

		<p className={cn.text} style={{ marginBottom: '1.5rem' }}>
			{' '}
			Please, check your Google and/or G-Suite account security settings
		</p>
		<Button
			as={Link}
			className={cn.action}
			to='/'
			typography={typo.largeButton}
			variant='bordered'
		>
			Back
		</Button>
	</AuthTemplate>
)
